import React,{Component} from 'react';
import './AdminClients.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import personsm from '../../../image/personsm.svg'
import AdminClientData from '../Components/AdminClientData/AdminClientData';
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';

class AdminClients extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            search:'',
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
    } 
    componentDidMount(){
        const Token =localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getclients`,{
            headers:{
              Authorization:`${Token}`
            }
          }).then(res =>{
            this.setState({
                data: res.data.reverse(),
                networkError: false,
                errordatamessage: false,
                hasError: false,
              })
              }).catch(error=>{

              if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                window.location.replace("/Admin/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext: error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
                  })
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    setStateField = (object) => e =>{
        this.setState({
            objectClient: object,
        })
  } 
    render(){  
        let  filteredContantsname = this.state.data.filter(
            (contact)=>{
                return contact.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        const itemdatatabel = filteredContantsname.map((x, i) => {
            return <div className="p-3 border-bottom item-table pointer" onClick={this.setStateField(x)} key={i}>
                                            
            <a ><img className="mr-3" src={personsm} alt="kayn user" /><span>{x.name}</span></a>
        </div>
        })
        return(
            <div>
                <div className="AppEN row   mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminClients Admin col-md-11 px-4">
                    <AdminHeaderTool/>
                    
                    <div className="row">
                    <h3 className="col-12 fontsize9 my-0 order-8 order-8 order-md-2">Clients</h3>

                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                            <AdminTableDetails itemdatatabel={itemdatatabel}  state={this.state} handleChange={this.handleChange}  />

                            </div>
                            <div className="col-md-8 px-4 py-3 order-5"> 
                                    
                                    {(this.state.objectClient ?
                                        <AdminClientData  state={this.state} handleChange={this.handleChange} />
                                        :
                                        <div className="picbg">
                                            <p className="text-center fontsize4">No Client selected</p>
                                        </div>                                    )}
                            </div>
                            </div>

                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminClients;